import { render, staticRenderFns } from "./PersonalLeaveApplicationTable.vue?vue&type=template&id=a68a1696&scoped=true&"
import script from "./PersonalLeaveApplicationTable.vue?vue&type=script&lang=js&"
export * from "./PersonalLeaveApplicationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68a1696",
  null
  
)

export default component.exports